import "./ProjectsCarousel.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import projectsData from "../Data/projectsData";


const projectss = projectsData.filter(p => p.category === "ongoing");

const ProjectsCarousel = () => {
  const [currentIndexx, setCurrentIndexx] = useState(0);

  const visibleCardss = 4;
  const maxIndex = Math.max(0, projectss.length - visibleCardss);

  const nextSlidee = () => {
    setCurrentIndexx((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlidee = () => {
    setCurrentIndexx((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndexx((prev) =>
      prev >= maxIndex ? 0 : prev + 1
    );
  }, 3000);

  return () => clearInterval(interval);
}, [maxIndex]);


  return (
    <section className="project-showcase">
      <div className="project-showcase-header">
        <div className="project-showcase-heading">
          {/* <span className="project-eyebrow">OUR WORK</span> */}

          <h2>
            {/* Projects That <span>Make an Impact.</span>*/}
            Ongoing Projects
          </h2>

          {/* <p>
            Explore our ongoing infrastructure and electrical projects.
          </p> */}
        </div>

        <div className="project-navigation">
          <button
            type="button"
            className="project-nav-btn"
            onClick={prevSlidee}
            aria-label="Previous projects"
          >
            &lt;
          </button>

          <button
            type="button"
            className="project-nav-btn"
            onClick={nextSlidee}
            aria-label="Next projects"
          >
            &gt;
          </button>
        </div>
      </div>

      <div className="project-carousel-window">
        <div
          className="project-carousel-track"
          style={{
            "--project-index": currentIndexx,
          }}
        >

            {projectss.map((project) => (
              <Link
                to={`/project/${project.id}`}
                className="project-showcase-card"
                key={project.id}
              >
                <div className="project-showcase-image">
                  <img
                    src={project.image}
                    alt={project.title}
                    loading="lazy"
                  />

                  <div className="project-image-overlay">
                    <span>{project.category}</span>
                  </div>
                </div>

                <div className="project-showcase-info">
                  <h3>{project.title}</h3>

                  <span className="project-card-arrow">
                    &#8599;
                  </span>
                </div>
              </Link>
            ))}

        </div>
      </div>

      <div className="project-carousel-footer">
        <span>
          {String(currentIndexx + 1).padStart(2, "0")}
          {" — "}
          {String(Math.min(currentIndexx + visibleCardss, projectss.length)).padStart(2, "0")}
        </span>

        <div className="project-progress">
          <div
            className="project-progress-bar"
            style={{
              width: `${((currentIndexx + 1) / (maxIndex + 1)) * 100}%`,
            }}
          />
        </div>

        <span>
          {String(projectss.length).padStart(2, "0")} PROJECTS
        </span>
      </div>
    </section>
  );
};

export default ProjectsCarousel;